import useDialogPlayground from './useDialogPlayground'
import Dialog from '../../../../control/dialog/dialog'
import Button from '../../../../control/button/button'

type DialogPlaygroundType = ReturnType<typeof useDialogPlayground>
const DialogPlaygroundView = (props: DialogPlaygroundType) => {
    const { onRefDialogOne, onRefDialogTwo, onClickDialogOne, onClickDialogTwo, onClickApplicationAlertMessage } = props
    return (
        <div>
            <h1>Dialog</h1>
            <div>
                <Button variant="contained" color="primary" onClick={onClickDialogOne}>
                    Open Dialog one (Alert Message Type)
                </Button>
                <br />
                <br />
                <Button variant="contained" color="primary" onClick={onClickDialogTwo}>
                    Open Dialog two (Alert Confirm Type)
                </Button>
                <br />
                <br />
                <Button variant="contained" color="primary" onClick={onClickApplicationAlertMessage}>
                    Application Alert Message
                </Button>
            </div>
            <Dialog
                onRef={onRefDialogOne}
                type="alert-message"
                title="Title Dialog One"
                content="Lorem ipsum dolor sit amet, consectetuer adipiscing elit."
            />
            <Dialog
                onRef={onRefDialogTwo}
                type="alert-confirm"
                title="Title Dialog One"
                content="Lorem ipsum dolor sit amet, consectetuer adipiscing elit."
            />
        </div>
    )
}

const DialogPlayground = () => {
    const dialogPlaygroundModel = useDialogPlayground()
    return <DialogPlaygroundView {...dialogPlaygroundModel} />
}

export default DialogPlayground
